import * as i0 from '@angular/core';
import { Directive, HostBinding, Component, EventEmitter, ElementRef, Inject, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, mixinOpenChange, Forward, openChangeInput, openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import { __decorate } from 'tslib';
import '@fa-switch-sharedservices/web-elements/components/modal/modal';
import '@fa-switch-sharedservices/web-elements/components/modal-drawer/modal-drawer';
import '@fa-switch-sharedservices/web-elements/components/modal-mobile/modal-mobile';

class FadvModalAlertDirective extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.slotName = 'alert';
    }
}
FadvModalAlertDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalAlertDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
FadvModalAlertDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvModalAlertDirective, selector: "fadv-modal-alert", host: { properties: { "slot": "this.slotName" } }, exportAs: [""], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalAlertDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fadv-modal-alert', exportAs: '' }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });

class FadvModalBodyComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.display = 'block';
    }
}
FadvModalBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalBodyComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvModalBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvModalBodyComponent, selector: "fadv-modal-body", host: { properties: { "styles.display": "this.display" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-modal-body', template: '<ng-content></ng-content>' }]
        }], propDecorators: { display: [{
                type: HostBinding,
                args: ['styles.display']
            }] } });

class FadvModalButtonDirective {
    constructor() {
        this.slotName = 'footer';
    }
}
FadvModalButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalButtonDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvModalButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvModalButtonDirective, selector: "[fadvModalButton]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalButtonDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[fadvModalButton]' }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });

class FadvModalComponent extends mixinOpenChange(FadvBaseComponent) {
    constructor(el) {
        super(el);
        this.size = 'medium';
        this.preventClosing = true;
        this.closeRequested = new EventEmitter();
    }
    handlePreventClosingChange(event) {
        if (!this.preventClosing) {
            this.closeRequested.emit(event);
        }
        else {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
FadvModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvModalComponent, selector: "fadv-modal", inputs: { open: "open", noHeader: "noHeader", label: "label", size: "size", preventClosing: "preventClosing" }, outputs: { openChange: "openChange", shown: "shown", hidden: "hidden", closeRequested: "closeRequested" }, host: { listeners: { "sl-request-close": "handlePreventClosingChange($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvModalComponent.prototype, "noHeader", void 0);
__decorate([
    Forward()
], FadvModalComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvModalComponent.prototype, "size", void 0);
__decorate([
    Forward()
], FadvModalComponent.prototype, "preventClosing", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-modal',
                    template: '<ng-content></ng-content>',
                    inputs: [openChangeInput],
                    outputs: [openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { noHeader: [{
                type: Input
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }], preventClosing: [{
                type: Input
            }], closeRequested: [{
                type: Output
            }], handlePreventClosingChange: [{
                type: HostListener,
                args: ['sl-request-close', ['$event']]
            }] } });

class FadvModalDrawerComponent extends FadvModalComponent {
}
FadvModalDrawerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalDrawerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvModalDrawerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvModalDrawerComponent, selector: "fadv-modal-drawer", inputs: { variant: "variant" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvModalDrawerComponent.prototype, "variant", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalDrawerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-modal-drawer',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { variant: [{
                type: Input
            }] } });

class FadvModalHeaderDirective extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.slotName = 'label';
    }
}
FadvModalHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalHeaderDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
FadvModalHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvModalHeaderDirective, selector: "fadv-modal-header", host: { properties: { "slot": "this.slotName" } }, exportAs: [""], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalHeaderDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fadv-modal-header', exportAs: '' }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });

class FadvModalMobileComponent extends mixinOpenChange(FadvBaseComponent) {
    constructor(el) {
        super(el);
    }
}
FadvModalMobileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalMobileComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvModalMobileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvModalMobileComponent, selector: "fadv-mobile-modal", inputs: { open: "open", desktop: "desktop", mobile: "mobile", breakpoint: "breakpoint" }, outputs: { openChange: "openChange", shown: "shown", hidden: "hidden" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvModalMobileComponent.prototype, "desktop", void 0);
__decorate([
    Forward()
], FadvModalMobileComponent.prototype, "mobile", void 0);
__decorate([
    Forward()
], FadvModalMobileComponent.prototype, "breakpoint", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalMobileComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-mobile-modal',
                    template: '<ng-content></ng-content>',
                    inputs: [openChangeInput],
                    outputs: [openChangeChangeOutput, openChangeShownOutput, openChangeHiddenOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { desktop: [{
                type: Input
            }], mobile: [{
                type: Input
            }], breakpoint: [{
                type: Input
            }] } });

class FadvModalModule {
}
FadvModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvModalModule, declarations: [FadvModalComponent,
        FadvModalAlertDirective,
        FadvModalDrawerComponent,
        FadvModalMobileComponent,
        FadvModalBodyComponent,
        FadvModalHeaderDirective,
        FadvModalButtonDirective], imports: [FadvCommonModule], exports: [FadvModalComponent,
        FadvModalAlertDirective,
        FadvModalDrawerComponent,
        FadvModalMobileComponent,
        FadvModalBodyComponent,
        FadvModalHeaderDirective,
        FadvModalButtonDirective] });
FadvModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FadvModalComponent,
                        FadvModalAlertDirective,
                        FadvModalDrawerComponent,
                        FadvModalMobileComponent,
                        FadvModalBodyComponent,
                        FadvModalHeaderDirective,
                        FadvModalButtonDirective,
                    ],
                    imports: [FadvCommonModule],
                    exports: [
                        FadvModalComponent,
                        FadvModalAlertDirective,
                        FadvModalDrawerComponent,
                        FadvModalMobileComponent,
                        FadvModalBodyComponent,
                        FadvModalHeaderDirective,
                        FadvModalButtonDirective,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvModalAlertDirective, FadvModalBodyComponent, FadvModalButtonDirective, FadvModalComponent, FadvModalDrawerComponent, FadvModalHeaderDirective, FadvModalMobileComponent, FadvModalModule };
